import { AppState } from '../reducers';

export const getAppSelector = (state: AppState) => state.app;

export const getPlanSelector = (state: AppState) => state.plan;

export const getDataPrivacyTermsSelector = (state: AppState) => state.dataPrivacyTerms;
